export default __webpack_public_path__ + "static/media/linkedinDark.16561909.svg";